<template>
  <div class="main" style="display: flex; flex-direction: column">
    <div style="border-bottom: 5px solid #f3f3f3; padding: 0px 14px 0px 12px; margin: auto" class="enter-x-1">
      <h1 class="gleaming" style="margin-left: 0px">K</h1>
      <h1 class="gleaming small">gms</h1>
    </div>

    <!-- ロゴ -->
    <!-- <img src="../../../public/kaimadata_logo.png" class="img-logo" /> -->
    <a-form :form="form" class="user-layout-login" ref="formLogin" id="formLogin">
      <!-- <a-avatar icon="user" /> -->

      <a-form-item class="enter-x-2">
        <a-input
          size="large"
          v-decorator="['username', validatorRules.username, { validator: this.handleUsernameOrEmail }]"
          type="text"
          allowClear
        >
          <a-icon slot="prefix" type="idcard" />
        </a-input>
      </a-form-item>

      <a-form-item class="enter-x-3">
        <a-input
          v-decorator="['password', validatorRules.password]"
          size="large"
          type="password"
          autocomplete="false"
          allowClear
        >
          <a-icon slot="prefix" type="lock" />
        </a-input>
      </a-form-item>

      <a-form-item style="margin-top: 55px; margin-bottom: 0" class="enter-x-4">
        <a-button
          size="large"
          type="primary"
          htmlType="submit"
          class="login-button"
          :loading="loginBtn"
          @click.stop.prevent="handleSubmit"
          :disabled="loginBtn"
        >
          <img
            src="~@/assets/loginBtn.png"
            style="width: 44px; position: relative; top: -2px; filter: drop-shadow(0px 0px 0px); color: white"
          />
          <!--确 定-->
        </a-button>
        <!-- <a style="display: block;width: 100%;text-align: center;color: #bbb;font-family: 'kgms5';">Login with SSO</a> -->
      </a-form-item>

      <!-- <a-form-item style="margin-top:28px">
        <a-select
          :default-value="dds"
          @change="handleDDSChange"
          style="min-width: 120px; max-width: 180px; width: auto;top: -1px;position: relative;"
        >
          <a-select-option value="biz01">楷码集团信息系统</a-select-option>
        </a-select>

        <a-radio-group style="float: right;margin-top: 3px;" :defaultValue="currentLocale.value">
          <a-radio-button v-for="locale in locales" :key="locale.value" :value="locale.value" @click="changeLocale">{{
            currentLocale['text_' + locale.value]
          }}</a-radio-button>
        </a-radio-group>
      </a-form-item> -->

      <p class="copyright">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" style="color: var(--color-grey)"
          >蜀ICP备08106074号-2</a
        >
        <br />
        成都楷码信息技术有限公司 版权所有
      </p>
    </a-form>

    <!-- バージョン管理 -->
    <!--<a-modal
      :width="500"
      :visible="versionVisible"
      :closable="false"
      :maskClosable="false"
      :footer="null"
      :centered="true"
    >
      <div style="text-align: center; margin: 10px 0px 10px 5px">
        <a-icon type="exclamation-circle" theme="twoTone" twoToneColor="#FAAD14" style="font-size: 60px" />
      </div>
      <div style="text-align: center; font-size: 18px; padding: 20px 0; line-height: 30px">
        检测出代码变动，<br />
        请按下「 <span style="font-weight: 500; color: green">Ctrl</span> +
        <span style="font-weight: 500; color: green">F5</span> 」的组合键刷新缓存
      </div>
    </a-modal>-->
  </div>
</template>

<script>
import axios from 'axios'
import { mixin, mixinDevice } from '@/utils/mixin.js'
import { mapActions } from 'vuex'
import Vue from 'vue'
import { ACCESS_TOKEN, ENCRYPTED_STRING } from '@/store/mutation-types'
import { putAction, postAction, getAction } from '@/api/manage'
import store from '@/store/'

export default {
  components: {},
  inject: ['changeAppLocale', 'wsReceived'],
  mixins: [mixin, mixinDevice],
  data() {
    return {
      loginBtn: false,
      form: this.$form.createForm(this),
      dds: Vue.ls.get('DDS') || 'master',
      //versionVisible: false,
      isDebug: window._CONFIG['isDebug'] ? true : false,
      locales: [...window.locales].reverse(),
      currentLocale: XEUtils.first(XEUtils.filter(window.locales, (item) => item.value == Vue.ls.get('Locale'))),
    }
  },
  mounted() {
    if (document.querySelector('.font-bold')) {
      document.querySelector('.font-bold').classList.remove('font-bold')
    }

    var url = `//${window.location.host}/version.json?t=${new Date().getTime()}`
    axios.get(url).then((res) => {
      if (res.status === 200) {
        if (res.data.isUnderMaintenance) {
          localStorage['maintenanceUntil'] = res.data.maintenanceUntil
          window.vm.$router.push({ path: '/503' })
        } else {
          localStorage['maintenanceUntil'] = undefined

          url = `//${window.location.host}/notice.json?t=${new Date().getTime()}`
          axios.get(url).then((res) => {
            if (res.status === 200) {
              if (res.data.loginNotice) {
                this.wsReceived(res.data.loginNoticeContent)
              }
            }
          })
        }
      }
    })

    Vue.ls.remove(ACCESS_TOKEN)
    this.getRouterData()

    // 强制设置为biz01,多租户库运用开始后需要放开
    if (!Vue.ls.get('DDS') || true) {
      Vue.ls.set('DDS', 'master')
    }

    // 开发环境用
    if (this.isDebug) {
      this.form.setFieldsValue({
        username: 'admin',
        password: 'Aaa111+++',
      })
    }

    // var random = function(min, max) {
    //   return min + Math.floor(Math.random() * (max - min + 1))
    // }
    // var heading = document.querySelector('h1.gleaming')
    // var letters = heading.textContent.split('')
    // heading.textContent = ''
    // letters.forEach(function(letter, index) {
    //   var span = document.createElement('span')
    //   span.textContent = letter
    //   span.style.animationDelay = random(1000, 2000) + 'ms'
    //   heading.append(span)
    // })

    // heading = document.querySelector('h1.gleaming.small')
    // letters = heading.textContent.split('')
    // heading.textContent = ''
    // letters.forEach(function(letter, index) {
    //   var span = document.createElement('span')
    //   span.textContent = letter
    //   span.style.animationDelay = random(1000, 2000) + 'ms'
    //   heading.append(span)
    // })
  },
  computed: {
    validatorRules() {
      return {
        username: {
          rules: [this._r.required],
        },
        password: {
          rules: [this._r.required],
        },
      }
    },
  },
  methods: {
    ...mapActions(['Login', 'Logout', 'PhoneLogin']),
    handleSubmit(e) {
      let that = this
      let loginParams = {}
      that.loginBtn = true

      // 使用账户密码登陆
      that.form.validateFieldsAndScroll(['username', 'password'], { force: true }, (err, values) => {
        if (!err) {
          loginParams.username = values.username
          loginParams.password = values.password
          loginParams.dds = that.dds

          that
            .Login(loginParams)
            .then((res) => {
              this.departConfirm(res)
            })
            .catch((err) => {
              that.loginBtn = false
            })
        } else {
          that.loginBtn = false
        }
      })
    },
    loginSuccess() {
      this.$getDict(null, null, true)
      this.$getDepartTree(null, true)
      this.$getPosition(null, true)
      this.$getBizLine(null, true)
      sessionStorage.removeItem('SYS_COMPANY_TREE')

      this.$notification.success({
        message: this.$t('msg.I_K0013001_04').format(this.$store.getters.userInfo.realname),
        duration: 2,
      })

      //setTimeout(() => {
      //  var el = document.querySelector('.div-content')
      //  el.classList.remove('animate__backInDown')
      //  el.classList.add('animate__fadeOutUp')
      //}, 400)

      setTimeout(() => {
        this.$router.push({ path: '/dashboard/analysis' })
      }, 700)
    },
    changeLocale(e) {
      if (e.target.value == Vue.ls.get('Locale')) {
        return
      }

      try {
        this.changeAppLocale(e.target.value)
        this.currentLocale = XEUtils.first(XEUtils.filter(window.locales, (item) => item.value == Vue.ls.get('Locale')))

        this.$nextTick(() => {
          if (this.form.getFieldsError().username) {
            this.form.validateFieldsAndScroll(['username'], { force: true }, (err, values) => {})
          }
          if (this.form.getFieldsError().password) {
            this.form.validateFieldsAndScroll(['password'], { force: true }, (err, values) => {})
          }
        })
      } catch {
        this.$notification.error({
          message: this.$t('disp.error'),
          description: this.$t('msg.loadLangPackageFail'),
        })
      }
    },
    departConfirm(res) {
      if (res.success) {
        if (
          res.result.userInfo.relations.length == 0 &&
          !XEUtils.isNull(res.result.userInfo.employeeType) &&
          !XEUtils.isNull(res.result.userInfo.entryDay)
        ) {
          this.loginBtn = false

          this.$notification.error({
            message: this.$t('disp.noDepart'),
            duration: 4,
          })
        } else {
          this.loginSuccess()
        }
      } else {
        this.Logout()
      }
    },
    getRouterData() {
      this.$nextTick(() => {
        if (this.$route.params.username) {
          this.form.setFieldsValue({
            username: this.$route.params.username,
          })
        }
      })
    },
    handleDDSChange(e) {
      this.dds = e
      Vue.ls.set('DDS', e)
    },
  },
}
</script>

<style lang="less" scoped>
.user-layout-login {
  background: white;
  height: 100%;
  z-index: 99;
  margin-top: 47px;

  label {
    font-size: 14px;
    line-height: 30px;
  }

  :global(.ant-form-explain) {
    text-indent: 58px;
    margin-top: 0;
    font-size: 14px;
  }

  :global(.ant-avatar) {
    width: 90px;
    height: 90px;
    font-size: 62px;
    padding-top: 10px;
    margin: 40px 0 40px 0;
    left: 37%;
    transition: all 0.8s;
  }

  :global(.ant-input) {
    height: 55px;
    border: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 0;
    padding-left: 65px !important;
    letter-spacing: 3px;
    transition: all 0.3s;
    font-size: 20px;
    padding-top: 0;
    padding-bottom: 0;
    color: rgb(100, 100, 100);

    &::-webkit-input-placeholder {
      letter-spacing: 3px;
      font-size: 16px;
    }
  }

  :global(.ant-form-item-control.has-error .ant-input) {
    box-shadow: none !important;
    border-bottom: 1px solid #f5222d !important;
  }

  :global(.ant-input-prefix .anticon) {
    font-size: 20px;
    margin-top: 0px;
    margin-left: 5px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .img-captcha {
    margin-top: 0px;
    width: 116px;
    height: 45px;
    cursor: pointer;
    transition: all 0.3s;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    padding: 0 15px 0px 17px;
    font-size: 18px;
    height: 47px;
    width: 100%;
    border: none;
    border-radius: 24px;
    //margin: 0 6%;
    filter: drop-shadow(0px 2px 6px #ccc);
  }

  button.login-button:disabled {
    filter: none;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }

  /deep/ .ant-select-selection {
    border: 1px solid #e5e5e5;
  }

  .ant-radio-button-wrapper {
    border: none;
    outline: none;
    box-shadow: none !important;
    padding: 0 10px;
  }

  .ant-radio-button-wrapper:last-child {
    padding: 0 12px;
  }

  .ant-radio-button-wrapper:last-child::before {
    position: absolute;
    top: 2px;
    left: 0px;
    display: block;
    width: 1px;
    height: 80%;
    background-color: #e5e5e5 !important;
    content: '';
    opacity: 1;
  }
}

/deep/ .gleaming {
  font-size: 62px;
  font-family: kgms3;
  display: inline-block;
  margin-bottom: 0;
  filter: drop-shadow(4px 2px 4px #ccc);
  /* text-shadow: 1px 1px 0 black; */
  font-weight: 400 !important;

  span {
    opacity: 0;
    filter: blur(10px);
    animation: spinning 2s alternate both;
    animation-iteration-count: 1;
  }

  &.small {
    font-size: 60px;
    font-weight: 400;
    letter-spacing: 2px;
    //color: #192d4b;
    color: #000;
    font-family: kgms3;
    padding-left: 0px;
    text-shadow: none;
    text-align: center;
    margin-left: 8px;
  }
}

@keyframes spinning {
  50%,
  100% {
    opacity: 1;
    filter: blur(0px);
  }
}

.gleaming.small /deep/ span {
  display: inline-block;
  letter-spacing: 3px;
  white-space: pre;
}
</style>
<style lang="less">
.valid-error .ant-select-selection__placeholder {
  color: #f5222d;
}

.img-logo {
  position: absolute;
  width: calc(70%);
  margin-top: -120px;
  filter: blur(15px) drop-shadow(2px 4px 6px #999) saturate(1.8);
  opacity: 0;
  animation: spinning2 2s both;
  animation-delay: 1s;
  margin-left: 34px;
  visibility: hidden;
}

@keyframes spinning2 {
  100% {
    opacity: 1;
    filter: blur(0px) drop-shadow(2px 4px 6px #999) saturate(1.8);
  }
}

p.copyright {
  position: absolute;
  bottom: 0px;
  letter-spacing: 0px;
  color: var(--color-grey);
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  //font-style: italic;
  background: linear-gradient(180deg, #f6f6f6, #fff);
  padding: 9px 0 11px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
}

.ant-btn-loading img {
  display: none;
}

// .ant-input-affix-wrapper:hover .ant-input:not(.ant-input-disabled) {
//   border-color: #70ae80 !important;
// }

//.enter-x-1::before {
//  content: '';
//  width: 9px;
//  height: 9px;
//  display: block;
//  background: #eee;
//  border-radius: 50%;
//  position: absolute;
//  bottom: -7px;
//  left: -15px;
//}

//.enter-x-1::after {
//  content: '';
//  width: 9px;
//  height: 9px;
//  display: block;
//  background: #eee;
//  border-radius: 50%;
//  position: absolute;
//  bottom: -7px;
//  right: -15px;
//}
</style>
